export default {
    publicClientAttrJuridicalValidateMutation(state, data) {
        state.attrsJuridical = data;
    },
    publicClientAttrPhisicalValidateMutation(state, data) {
        state.attrsPhisical = data;
    },
    clientPublicTypeMutation(state, data) {
        state.clientPublicType = data;
    },
    listAnnexTypePublicMutation(state, data) {
        state.typesAnnex = data;
    },
    listMaritalStatusesPublicMutation(state, data) {
        state.maritalStatusesOptions = data;
    },
    setNaturalPersonPublicMutation(state, data) {
        state.naturalPerson = data;
    },
    setLegalPersonPublicMutation(state, data) {
        state.legalPerson = data;
    },
    setAddressPublicClientMutation(state, data) {
        state.address = data;
    },
    setCommercialAddressPublicClientMutation(state, data) {
        state.commercialAddress = data;
    },
    setSpousePublicClientMutation(state, data) {
        state.spouse = data;
    },
    setSpouseFillModePublicClientMutation(state, data) {
        state.spouse.fillMode = data;
    },
    setResponsiblePublicClientMutation(state, data) {
        state.responsible = data;
    },
    setResponsibleFillModePublicClientMutation(state, data) {
        state.responsible.fillMode = data;
    },
    setAnexesPublicClientMutation(state, data) {
        state.anexes = data;
    },
    pushAnexesPublicClientMutation(state, data) {
        state.anexes.push(data);
    },
    clearStatePubliClientMutation(state) {
        state.clientPublicType = null;
        state.naturalPerson = {};
        state.legalPerson = {};
        state.address = {
            cep: null,
            street: null,
            number: null,
            neighborhood: null,
            complement: null,
            description: null,
        };
        state.commercialAddress = {
            cep: null,
            street: null,
            number: null,
            neighborhood: null,
            complement: null,
            description: null,
        };
        state.spouse = {
            fillMode: 'search',
        };
        state.responsible = {
            fillMode: 'search',
        };
        state.anexes = [];
        state.requiredConjuge = false;
    },
    changeConjugeRequiredPersonPublicMutation(state, data){
        state.requiredConjuge = data;
    }
}